import React from "react";
import { useDropzone } from "react-dropzone";
import { Button } from "react-bootstrap";
import { BsTrash } from "react-icons/bs";
import FilePreviewer from "./FilePreviewer";

const MAX_FILE_SIZE_MB = 5;

const DEFAULT_ACCEPTED_TYPES = {
  "application/pdf": [".pdf"],
  "image/*": [".jpg", ".jpeg", ".png"],
};

const DocumentDropZoneUploader = ({
  documentKey,
  onFileSelect,
  uploadedFile,
  onRemove,
  allowRemove = true,
  acceptedTypes,
  helperText,
}) => {
  const handleDrop = (acceptedFiles) => {
    const file = acceptedFiles[0];
    if (!file) return;

    if (file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
      alert(`File size must be under ${MAX_FILE_SIZE_MB}MB`);
      return;
    }

    onFileSelect(documentKey, file);
  };

  const { getRootProps, getInputProps, open } = useDropzone({
    onDrop: handleDrop,
    noClick: true,
    noKeyboard: true,
    multiple: false,
    accept: acceptedTypes || DEFAULT_ACCEPTED_TYPES,
  });

  return (
    <div className="position-relative mt-2">
      {uploadedFile && (
        <div className="mb-3 position-relative">
          <FilePreviewer fileSource={uploadedFile} />
          {allowRemove && (
            <Button
              variant="outline-danger"
              size="sm"
              className="position-absolute top-0 end-0 m-2"
              onClick={() => onRemove(documentKey)}
            >
              <BsTrash title="Delete file" />
            </Button>
          )}
        </div>
      )}

      {!uploadedFile && (
        <div
          {...getRootProps()}
          className="border border-2 rounded p-4 text-center"
          style={{
            borderStyle: "dashed",
            backgroundColor: "#f9f9f9",
            color: "#6c757d",
          }}
        >
          <input {...getInputProps()} />
          <div className="fw-semibold mb-1">Upload File</div>
          <div className="small mb-3">Drag and drop or browse to upload</div>
          <Button
            variant="light"
            className="fw-semibold px-3 py-1 shadow-sm m-auto"
            onClick={open}
          >
            Browse Files
          </Button>
          {helperText && (
            <div className="small text-muted mt-3">{helperText}</div>
          )}
        </div>
      )}
    </div>
  );
};

export default DocumentDropZoneUploader;
